import React from 'react'

interface UIStaightlineProressBarProps {
  percentage: number
  label: string
  stroke: string
  strokeWidth: number
}

const UIStaightlineProressBar: React.FC<UIStaightlineProressBarProps> = ({
  percentage,
  label,
  stroke,
  strokeWidth,
}) => {

  return (
    <div className="w-full">
      <div className="flex">
        <p className="text-xs font-medium leading-5 text-text4 flex-1">
          {label}
        </p>
        <p className="text-xs font-medium leading-5 text-text2">{`${percentage}%`}</p>
      </div>
      <div
        style={{
          height: `${strokeWidth * 4}px`,
        }}
        className={`w-full rounded-full bg-gray3 mt-3`}
      >
        <div
          className={`rounded-full`}
          style={{
            width: `${percentage}%`,
            backgroundColor: stroke,
            height: `${strokeWidth * 4}px`,
          }}
        ></div>
      </div>
    </div>
  )
}

export default UIStaightlineProressBar
